export const config = {
    name: 'Staff pick tag',
};
